// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "[data-v-1878165a] .el-input-group__prepend {\n  background-color: #f5f7fa;\n}", "",{"version":3,"sources":["/builds/front/game-platform-web/src/components/LanguageInputEcho/index.vue"],"names":[],"mappings":"AACA;EACE,yBAAA;AAAF","file":"index.vue","sourcesContent":["\n::v-deep .el-input-group__prepend {\n  background-color: #f5f7fa;\n}\n"]}]);
// Exports
module.exports = exports;
